<template>
  <Head title="Results - Publish Plan" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <publish-plan :plans="plans" :client="client"></publish-plan>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  plans: Array,
  client: Object
});
</script>

